import React from "react";
import { useAuth } from "../contexts/AuthContext";

const Profile = () => {
  const { user, loggedIn, isAuthenticated, refreshtoken, token, watchDate } = useAuth(); 
  console.log(user)
  console.log(loggedIn)
  return (
    <div className="container">
      <header className="jumbotron">
        <h3>Profile</h3>
        <h4>User is { loggedIn? "" : "not "} Logged In</h4>
        <h4>Token</h4>
        <p>{token}</p>
        <h4>Refresh Token</h4>
        <p>{refreshtoken}</p>
        <h4>Watch Date - {refreshtoken}</h4>
        <strong>Content of User: </strong>
        <p style={{'width': '500px', 'wordBreak': 'break-all'}}>{JSON.stringify(user)}</p>
      </header>
    </div>
  );
};

export default Profile;